import { Component, NgZone, OnInit } from '@angular/core'
import { RestServices } from '../../services/rest.services'
import { AuthService } from '../../services/auth.services'
import { CookieService } from 'ngx-cookie-service'
import { ActivatedRoute, Router } from '@angular/router'
import { versionWeb } from '../../../helper/common'

declare var cordova: any
declare var navigator: any;

(window as any).handleOpenURL = (url: string) => {
    (window as any).handleOpenURL_LastURL = url
}

@Component({
    selector: 'app-login-token',
    templateUrl: './login-token.component.html',
    styleUrls: ['./login-token.component.css'],
})
export class LoginTokenComponent implements OnInit {
    versionWeb = versionWeb
    login = true
    showError = false
    activantionCode
    secretToken
    previewMode = false
    account_id
    urlScheme = ''

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authData: AuthService,
        private checkLogin: RestServices,
        private cookieService: CookieService,
        private zone: NgZone,
    ) {
        if (navigator.splashscreen) navigator.splashscreen.hide();
        (window as any).handleOpenURL = (url: string) => {
            setTimeout(() => {
                this.handleOpenUrl(url)
            }, 0)
        }
        // check if app was opened by custom url scheme
        const lastUrl: string = (window as any).handleOpenURL_LastURL || ''
        if (lastUrl && lastUrl !== '') {
            delete (window as any).handleOpenURL_LastURL
            this.handleOpenUrl(lastUrl)
        }
    }

    private handleOpenUrl(url: string) {
        this.urlScheme = url
        this.sendRequest(url)
    }

    ngOnInit() {
        if (
            this.route.url['value'][2] &&
            this.route.url['value'][2].path == 'preview'
        ) {
            this.previewMode = true
        } else if (
            this.route.url['value'][2] &&
            this.route.url['value'][2].path === 'click_event' &&
            this.route.url['value'][3] &&
            this.route.url['value'][3].path == 'move_to_page_chat'
        ) {
            if (this.authData.getItem('user')) {
                const dataUser = this.authData.getUser()
                // console.log(a);
                if (dataUser.clientId && dataUser.appMobile) {
                    this.router.navigateByUrl(
                        '/client/main/' + dataUser.clientId + '/click_event/move_to_page_chat',
                    )
                }
            }
        } else {
            // console.log('login');
            if (this.authData.getItem('user')) {
                const dataUser = this.authData.getUser()
                // console.log(a);
                if (dataUser.clientId && dataUser.appMobile) {
                    this.router.navigateByUrl('/client/main/' + dataUser.clientId)
                }
            }
        }
    }

    checkValue(val) {
        //console.log(val);
    }

    sendRequest(val) {
        let arrayParam = val.split('/')
        this.account_id = arrayParam[arrayParam.length - 2]
        let loginUrl = 'account/activationCode'
        let data = {
            accountId: this.account_id,
            activationToken: arrayParam[arrayParam.length - 1],
        }
        this.checkLogin.http_post(loginUrl, data).subscribe(
            (success) => {
                this.login = false
                if (success['responseCode'] == 'ActivationTokenAlreadyUsed') {
                    this.showError = true
                    this.secretToken = ''
                } else {
                    this.activantionCode = success['activationCode']
                    this.secretToken = success['activationSecret']
                }
                this.zone.run(() => {
                    this.login = this.login
                })
            },
            (err) => {
                this.login = true
            },
        )
    }

    sendRequestActive() {
        let loginUrl = 'account/login'
        let data = {
            accountId: this.account_id,
            activationSecret: this.secretToken,
        }
        this.checkLogin.http_post(loginUrl, data).subscribe(
            (success) => {
                if (!this.previewMode) {
                    this.router.navigateByUrl(
                        'client/main/' + success['clientId'],
                    )
                    this.authData.setItem('user', success)
                    this.authData.setItem('token', success['token'])
                    this.authData.setItem('timeout', Date.now())
                    this.cookieService.set('token', success['token'], 1)
                } else {
                    this.router.navigateByUrl(
                        'client/main/' + success['clientId'] + '/preview',
                    )
                }
            },
            (err) => {
                this.login = true
            },
        )
    }

    backLogin() {
        this.login = true
        this.showError = false
    }
    private openBarScanner(){
        cordova.plugins.barcodeScanner.scan(
            (result) => {
                let val = result.text
                let arrayParam = val.split('/')
                let loginUrl = 'account/activationCode'
                this.account_id = arrayParam[arrayParam.length - 2]
                let data = {
                    accountId: this.account_id,
                    activationToken: arrayParam[arrayParam.length - 1],
                }
                this.checkLogin.http_post(loginUrl, data).subscribe(
                    (success) => {
                        this.login = false
                        if (
                            success['responseCode'] ==
                            'ActivationTokenAlreadyUsed'
                        ) {
                            this.showError = true
                        } else {
                            this.activantionCode = success['activationCode']
                            this.secretToken = success['activationSecret']
                        }
                        this.zone.run(() => {
                            this.login = this.login
                        })
                    },
                    (err) => {
                        this.login = true
                    },
                )
            },
            function(error) {
                console.log('Scanning failed: ' + error)
            },
        )
    }
    private requestPermissionCamera(){
        const permissions = cordova.plugins.permissions;
        permissions.requestPermission(permissions.CAMERA, ( status ) => {
            if ( status.hasPermission ) {
                this.openBarScanner();
            }else{
                console.log("Please try to turn on camera permission in settings");
            }
        });
    }
    scanCode() {
        if (typeof cordova.plugins.permissions != 'undefined') {
        const permissions = cordova.plugins.permissions;
        permissions.hasPermission(permissions.CAMERA, ( status ) => {
            if ( status.hasPermission ) {
                this.openBarScanner();
            }
            else {
              this.requestPermissionCamera()
            }
          });
        }else{
            this.openBarScanner();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/client-app/login-token/login-token.component.ts